<ngx-spinner bdColor="rgb(0 0 0 / 61%)" size="medium" color="#f7a714 "[fullScreen]="true" type="ball-clip-rotate">
  <!-- <p style="color: white"> Loading... </p> -->
</ngx-spinner>
<router-outlet></router-outlet>
